<template>
    <div class="page-scan-out">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">澳門倉庫</div>
            <div class="breadcrumb-item">掃描出庫</div>
        </div>

        <div class="card-block">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <div class="pg-form-wrap">
                <Form :label-width="150">
                    <Row>
                        <Col span="11" push="6">
                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>出庫袋號</span>
                                </div>
                                <Input v-model="form.sack_number" ref='macao_scanout_id'  @keyup.enter.native="handleCheckFrom"/>
                            </FormItem>

                            <FormItem>
                                <div class="pg-btn-wrap pg-form-btn">
									<div class="pg-btn style2" @click="handleCheckFrom">出庫</div>
                                    <!-- <div class="pg-btn style1" style="margin-right: 20px;" @click="handleSearch">確定</div> -->
                                    <!-- <Button type="error" :loading="true" class="loading-btn">
                                         <span>Loading...</span>
                                     </Button>-->
                                </div>
                            </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>

            <Table size="small"
                   border
                   no-data-text="暫無數據"
                   :columns="table.column"
                   :data="table.data">
                <template slot-scope="{ row, index }" slot="action">
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style1" @click="handleDelete(index)">移出</div>
                    </div>
                </template>
            </Table>

        </div>
    </div>
    </div>
</template>

<script>
    export default {
        data()
        {
            return {
				err_audio: "https://jyb-admin-backend.aoyunltd.com/audio/music-fail.mp3",
				suc_audio: "https://jyb-admin-backend.aoyunltd.com/audio/music-success.mp3",
                form: {
                    sack_number: '',
                },
                isSubmiting: false,
                table: {
                    column: [
                        {
                            title: '序號',
                            key: 'id',
                            align: 'center',
                            minWidth: 70,
                            sortable: true
                        },
                        {
                            title: '出庫袋號',
                            key: 'sack_number',
                            align: 'center',
							sortable: true
                        },
                        {
                            title: '出庫時間',
                            key: 'macao_originating_out_time',
                            align: 'center',
							sortable: true
                        },
                        {
                            title: '操作人',
                            slot: 'action',
                            align: 'center',
                            sortable: true,
                            minWidth: 100
                        }
                    ],
                    data: []
                }
            };
        },
        mounted(){},
        methods: {
            //根據袋號獲取訂單列表
            getOrderBySackNo()
            {
                this.isSubmiting = true;
                this.$Rq.requestAuth({
                    url: this.$Api.macaoInList,
                    method: 'post',
                    data: {
                        status: 1,  //0已入库 , 1已出库
                        sack_number: this.form.sack_number
                        //sack_number: '101466295159',
                    }
                }).then((res) =>
                {
                    this.isSubmiting = false;
                    if (res.code == 0)
                    {
                        let resData = res.data.data;
                        let tempArr = [];

                        for (let i = 0, len = resData.length; i < len; i++)
                        {
                            tempArr.push({
                                id: resData[i].id,
                                sack_number: resData[i].sack_number,
                                macao_originating_time: resData[i].macao_originating_time,
                                macao_originating_out_time: resData[i].macao_originating_out_time,
                            });
							break;
                        }

                        this.table.data = tempArr.reverse();
                    }
                }).catch((err) =>
                {
                    this.isSubmiting = false;
                });
            },

            handleCheckFrom()
            {
                let form = this.form;
                if (form.sack_number === '')
                {
                    this.$Utils.showTipInfo('請輸入出庫袋號');
                    return;
                }

                this.handleSubmit();
				this.$refs.macao_scanout_id.focus();
				// this.form.sack_number= '';
            },

            handleSubmit()
            {
                let form = this.form;
                this.isSubmiting = true;

                this.$Rq.requestAuth({
                    url: this.$Api.macaoScanOut,
                    method: 'post',
                    data: {
                        sack_number: form.sack_number
                    }
                }).then((res) =>
                {
                    this.isSubmiting = false;

                    if (res.code == 0)
                    {
                        this.$Utils.showSuccess(res.msg);

                        // this.getOrderBySackNo();
                       
						let audio = new Audio()
						audio.src = this.suc_audio
						audio.play();
						this.getOrderBySackNo();
						this.form = {
						    sack_number: ''
						};
                    } else
                    {
                        this.$Utils.showTipInfo(res.msg);
						let audio = new Audio()
						audio.src = this.err_audio
						audio.play();
						this.form = {
						    sack_number: ''
						};
                    }
                }).catch((err) =>
                {
                    this.isSubmiting = false;
					let audio = new Audio()
					audio.src = this.err_audio
					audio.play();
					this.form = {
					    sack_number: ''
					};
                });
            },

            handleDelete(index)
            {
                this.$Modal.confirm({
                    title: '提示',
                    content: '確定移出嗎？',
                    cancelText: '取消',
                    okText: '確定',
                    onOk: () =>
                    {
                        let tableData = this.table.data;
                        this.isSubmiting = true;

                        this.$Rq.requestAuth({
                            url: this.$Api.delSack,
                            method: 'post',
                            data: {
                                id: tableData[index].id
                            }
                        }).then((res) =>
                        {
                            this.isSubmiting = false;

                            if (res.code == 0)
                            {
                                this.$Utils.showSuccess(res.msg);
                                tableData.splice(index, 1);
                                this.table.data = tableData;

                            } else
                            {
                                this.$Utils.showTipInfo(res.msg);
                            }
                        }).catch((err) =>
                        {
                            this.isSubmiting = false;
                        });
                    }
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "ScanOut";
</style>